import { FETCHING_ACCOUNT_WITHDRAW_INFOS, RECEIVE_ACCOUNT_WITHDRAW_INFOS, ACCOUNT_WITHDRAW_INFOS_ERROR, DELETE_WHITELISTED_ADDRESS } from '../actions/eotcWithdrawActions';
var initialState = {
  isLoading: false,
  error: '',
  withdrawInfos: []
};
export default function eotcWithdraw() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case FETCHING_ACCOUNT_WITHDRAW_INFOS:
      return Object.assign({}, state, {
        isLoading: true
      });
    case RECEIVE_ACCOUNT_WITHDRAW_INFOS:
      return Object.assign({}, state, {
        withdrawInfos: payload,
        error: '',
        isLoading: false
      });
    case ACCOUNT_WITHDRAW_INFOS_ERROR:
      return Object.assign({}, state, {
        error: payload,
        isLoading: false
      });
    case DELETE_WHITELISTED_ADDRESS:
      return Object.assign({}, state, {
        withdrawInfos: state.withdrawInfos.filter(function (i) {
          return i.AccountWithdrawInfoId !== payload;
        })
      });
    default:
      return state;
  }
}